import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharingFilesService {
  pickedFile = new BehaviorSubject({});

  constructor () { }
}
